import { env } from '../env';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useState } from "react";
import RICIBs from "react-individual-character-input-boxes";

function SmsValidation({ page, setPage }) {
  const [smsCode, setSmsCode] = useState("");

  // smsCode contient la saisie du code,
  // handleOutput tient à jour la saisie de smsCode
  const handleOutput = (codeInput) => setSmsCode(codeInput);

    const handleResend = () => { };
    const handleCancel = () => {
        const request = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                LK: env.REACT_APP_LICENCE_KEY,
                ENVID: env.REACT_APP_ENV_ID,
                Guid: page.smsGuid,
                Code: smsCode,
            }),
        };
        fetch(
            `${env.REACT_APP_PROXY_BASE_URL}/appointment/annulation`,
            request
        )
            .then((response) => response.json())
            .then((res) => {
                console.log(res.Success);
                if (res?.Success) {
                    setPage({
                        ...page,
                        page: 7,
                        smsConfirmation: false,
                        valid: false,
                    });
                } else {
                    setPage({
                        ...page,
                        page: 6,
                        smsConfirmation: false,
                        valid: false,
                    });
                }
            })
            .catch((err) =>
                setPage({
                    ...page,
                    page: 6,
                    smsConfirmation: false,
                    valid: false,
                })
            );
    };
  const handleSubmit = () => {
    const request = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        LK: env.REACT_APP_LICENCE_KEY,
        ENVID: env.REACT_APP_ENV_ID,
        Guid: page.smsGuid,
        Code: smsCode,
      }),
    };
    fetch(
      `${env.REACT_APP_PROXY_BASE_URL}/appointment/confirmation`,
      request
    )
      .then((response) => response.json())
      .then((res) => {
        console.log(res.Success);
        if (res?.Success) {
          setPage({
            ...page,
            page: 5,
            smsConfirmation: false,
            valid: true,
          });
        } else {
          setPage({
            ...page,
            page: 6,
            smsConfirmation: false,
            valid: false,
          });
        }
      })
      .catch((err) =>
        setPage({
          ...page,
          page: 6,
          smsConfirmation: false,
          valid: false,
        })
      );
  };

  return (
    <Dialog open={page.smsConfirmation} maxWidth="xl">
      <DialogTitle>
        <Typography variant="h5">Entrez votre code reçu par SMS</Typography>
        <Typography variant="h6">(Valable 5 minutes)</Typography>
      </DialogTitle>
      <DialogContent dividers>
        <RICIBs
          amount={6}
          autoFocus
          inputRegExp={/^[0-9]$/}
          handleOutputString={handleOutput}
          inputProps={{
            style: {
              border: "none",
              borderRadius: 0,
              borderBottom: "3px solid #3f50b5",
            },
          }}
        />
      </DialogContent>
      <DialogActions>
              <Button variant="contained" onClick={handleCancel} >
          Annuler
        </Button>
        <Button variant="contained" onClick={handleSubmit} >
            Valider
        </Button>
      </DialogActions>
    </Dialog>
    );
}

export default SmsValidation;
